export const addressFormToggles = () => {
  // There's already an id that's generated by the form helpers
  // We don't want to interfere with the label so we'll use a class instead
  const countryDropdown: HTMLElement = document.querySelector(".js-person-address-country-id")

  const regionField: HTMLElement = document.getElementById("js-region-dropdown")
  if (countryDropdown && regionField) {
    countryDropdown.addEventListener("change", (e: any) => {
      regionField.classList.toggle("js-hidden", e.target.value !== countryDropdown.dataset.usaId)
    })
  }

  const radios = document.querySelectorAll("#js-address-radios input[type=radio]")
  const newAddressForm = document.getElementById("js-new-address-form")

  for (const r of radios) {
    r.addEventListener("change", (e: any) => {
      newAddressForm.classList.toggle("js-hidden", e.target.value !== "")
    })
  }
}
